import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { forwardRef } from 'react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var DesktopNavigation = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children;
  return _jsx(Wrapper, {
    ref: ref,
    children: children
  });
});

var Wrapper = /*#__PURE__*/_styled("nav", true ? {
  target: "e1iq8l410"
} : {
  target: "e1iq8l410",
  label: "Wrapper"
})(true ? {
  name: "10syivw",
  styles: "position:sticky;top:0;left:0;z-index:999;width:100%"
} : {
  name: "10syivw",
  styles: "position:sticky;top:0;left:0;z-index:999;width:100%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvTmF2aWdhdGlvbi9EZXNrdG9wTmF2aWdhdGlvbi9EZXNrdG9wTmF2aWdhdGlvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUTBCIiwiZmlsZSI6Ii93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvTmF2aWdhdGlvbi9EZXNrdG9wTmF2aWdhdGlvbi9EZXNrdG9wTmF2aWdhdGlvbi50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBmb3J3YXJkUmVmLCB0eXBlIFByb3BzV2l0aENoaWxkcmVuIH0gZnJvbSAncmVhY3QnXG5cbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5jb25zdCBEZXNrdG9wTmF2aWdhdGlvbiA9IGZvcndhcmRSZWY8SFRNTEVsZW1lbnQsIFByb3BzV2l0aENoaWxkcmVuPigoeyBjaGlsZHJlbiB9LCByZWYpID0+IChcbiAgPFdyYXBwZXIgcmVmPXtyZWZ9PntjaGlsZHJlbn08L1dyYXBwZXI+XG4pKVxuXG5jb25zdCBXcmFwcGVyID0gc3R5bGVkLm5hdmBcbiAgcG9zaXRpb246IHN0aWNreTtcbiAgdG9wOiAwO1xuICBsZWZ0OiAwO1xuICB6LWluZGV4OiA5OTk7XG4gIHdpZHRoOiAxMDAlO1xuYFxuXG5leHBvcnQgZGVmYXVsdCBEZXNrdG9wTmF2aWdhdGlvblxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default DesktopNavigation;